<script setup lang="ts">
import type { FieldVariants } from '../variants'
import type { HTMLAttributes } from 'vue'
import { cn } from '@/utils/shadcn/lib/utils'
import { fieldVariants } from '../variants'

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

const props = defineProps<{
  class?: HTMLAttributes['class']
  layout?: FieldVariants['layout']
  compact?: FieldVariants['compact']
}>()
</script>

<template>
    <div
        role="group"
        data-slot="field"
        :data-layout="layout"
        :class="cn(
            fieldVariants({ layout, compact }),
            props.class,
        )"
    >
        <slot></slot>
    </div>
</template>
